var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"youtube-video"},[_c('iframe',{attrs:{"id":"player","type":"text/html","width":"100%","height":"100%","src":`https://www.youtube.com/embed/${_vm.videoID}?enablejsapi=1&origin=https://elmalcamino.com`,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }